import styled from 'styled-components';

export const RecommendSection = styled.section(
  props => `
    width:100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom:25px;
    margin-top:25px;
    `,
);

export const BorderSpan = styled.span(
  props => `
    border:1px solid #98999e;
    width:35%;
    height:0.1rem;
    //background: #98999e;
      `,
);

export const RecommendTextSpan = styled.span(
  props => `
    padding-right:10px;
    padding-left:10px;
    display: flex;
    width:30%;
    justify-content:center;
    font-size: ${props.theme.font.custom(18)};
    font-weight: 600;
      `,
);
